import React, { FC, ReactNode } from 'react';
import { ContainedSelect } from '../index';
import { ContainedSelectPropsType } from './ContainedSelect';

interface ContainedSelectWithLabelProps extends ContainedSelectPropsType {
	title: string;
	classNameRoot?: string;
	classNameLabel?: string;
	classNameWrapper?: string;
	required?: boolean;
	hasError?: boolean;
	labelBrother?: ReactNode;
}
const ContainedSelectWithLabel: FC<ContainedSelectWithLabelProps> = ({
	classNameRoot,
	classNameLabel,
	classNameWrapper,
	title,
	required = false,
	hasError = false,
	labelBrother,
	testId,
	...props
}) => (
	<div className={classNameRoot}>
		<div className={classNameWrapper}>
			<p className={classNameLabel}>
				{title}
				{required && <span style={{ color: 'red' }}>*</span>}
			</p>
			{labelBrother}
		</div>
		<ContainedSelect
			testId={testId}
			controlStyles={hasError ? {
				borderColor: 'red !important',
			} : {}}
			{...props}
		/>
	</div>
);

export default ContainedSelectWithLabel;
